export default "__VITE_ASSET__ub9HjYpK__"